'use client'

import { DatePicker, TimePicker } from '@graftcode/design-system'

import { TIME_RANGE_FILTER_TEST_IDS } from '@apps/service-map/service-map-test-ids.const'

import type { CustomRangeSectionProps } from './CustomRangeSection.types'

import styles from './CustomRangeSection.module.scss'

const FILTER_PICKER_PROPS = {
  size: 'sm' as const,
  appearance: 'compact' as const,
}

const DATE_PLACEHOLDER = 'DD/MM/YYYY'

export function CustomRangeSection({
  startDate,
  startTime,
  endDate,
  endTime,
  labels,
  hour12,
  dateFormat,
  layout = 'desktop',
  onStartDateChange,
  onStartTimeChange,
  onEndDateChange,
  onEndTimeChange,
}: CustomRangeSectionProps) {
  const rootClassName = layout === 'mobile' ? `${styles.root} ${styles.rootMobile}` : styles.root

  return (
    <div className={rootClassName} data-testid={TIME_RANGE_FILTER_TEST_IDS.customRangeSection}>
      <div className={styles.block}>
        <p className={styles.label}>{labels.startTime}</p>
        <div className={styles.row}>
          <DatePicker
            {...FILTER_PICKER_PROPS}
            value={startDate}
            format={dateFormat}
            placeholder={DATE_PLACEHOLDER}
            ariaLabel={labels.startDateAriaLabel ?? labels.startDate}
            onChange={onStartDateChange}
          />
          <TimePicker
            {...FILTER_PICKER_PROPS}
            value={startTime}
            hour12={hour12}
            uppercasePeriod={hour12}
            ariaLabel={labels.startTimeAriaLabel ?? labels.startTime}
            onChange={onStartTimeChange}
          />
        </div>
      </div>

      <div className={styles.block}>
        <p className={styles.label}>{labels.endTime}</p>
        <div className={styles.row}>
          <DatePicker
            {...FILTER_PICKER_PROPS}
            value={endDate}
            format={dateFormat}
            placeholder={DATE_PLACEHOLDER}
            ariaLabel={labels.endDateAriaLabel ?? labels.endDate}
            onChange={onEndDateChange}
          />
          <TimePicker
            {...FILTER_PICKER_PROPS}
            value={endTime}
            hour12={hour12}
            uppercasePeriod={hour12}
            ariaLabel={labels.endTimeAriaLabel ?? labels.endTime}
            onChange={onEndTimeChange}
          />
        </div>
      </div>
    </div>
  )
}
